module.exports = __webpack_public_path__ + "static/media/logo-grejo.05ca4e4c.png";